import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { useCurrentBusinessId } from './useCurrentBusinessId';

interface UseBusinessRoleResult {
  role: API.BusinessRole | undefined;
  isBusinessAdmin: boolean | undefined;
  refetch: VoidFunction;
  loading: boolean;
}

export function useBusinessRole(): UseBusinessRoleResult {
  const businessId = useCurrentBusinessId();
  const { data, refetch, loading } = useQuery<
    API.BusinessRoleQuery,
    API.BusinessRoleQueryVariables
  >(Queries.user.businessRole, {
    variables: { businessId: businessId ?? -1 },
    skip: isNil(businessId),
  });
  return useMemo(() => {
    return {
      role: data?.me?.role ?? undefined,
      isBusinessAdmin: data?.me?.isBusinessAdmin ?? undefined,
      refetch,
      loading,
    };
  }, [data, refetch, loading]);
}
